import { StepFormBase } from 'core/components';
import _ from 'lodash';

export default class ProductEditForm extends StepFormBase {
	constructor(hooks) {
		super(hooks);
		this.setForm(this);
	}

	setup() {
		return {
			...this.getMergedForm([
				ProductEditGeneralStepForm(),
				ProductEditDimensionsStepForm(),
				ProductEditVirtualSKUStepForm(),
			]),
		};
	}
}

function ProductEditGeneralStepForm() {
	return {
		fields: [
			'generalStep.sellerId',
			'generalStep.mainSku',
			'generalStep.onePerBox',
			'generalStep.name',
			'generalStep.description',
			'generalStep.asin',
			'generalStep.productUpcs',
			'generalStep.productUpcs[].id',
			'generalStep.productUpcs[].upc',
			'generalStep.conditionId',
			'generalStep.productCategoryId',
			'generalStep.productStatusId',
			'generalStep.isMultiProduct',
			'generalStep.productPartQuantity',
			'generalStep.isShippable',
			'generalStep.isActive',
			'generalStep.nmfcCode',
			'generalStep.freightClassCode',
		],
		labels: {
			'generalStep.sellerId': 'PRODUCTVIEW.SELLER',
			'generalStep.mainSku': 'PRODUCTVIEW.PRODUCTSKU',
			'generalStep.onePerBox': 'PRODUCTVIEW.ONEPERBOX',
			'generalStep.name': 'PRODUCTVIEW.NAME',
			'generalStep.description': 'PRODUCTVIEW.DESCRIPTION',
			'generalStep.asin': 'PRODUCTVIEW.ASIN',
			'generalStep.productUpcs[].upc': 'PRODUCTVIEW.UPC',
			'generalStep.conditionId': 'PRODUCTVIEW.CONDITION',
			'generalStep.productCategoryId': 'PRODUCTVIEW.PRODUCTCATEGORY',
			'generalStep.productStatusId': 'PRODUCTVIEW.PRODUCTSTATUS',
			'generalStep.isMultiProduct': 'PRODUCTVIEW.ISMULTIPACKAGE',
			'generalStep.productPartQuantity': 'PRODUCTVIEW.QUANTITY',
			'generalStep.isShippable': 'PRODUCTVIEW.ISSHIPPABLE',
			'generalStep.nmfcCode': 'PRODUCTVIEW.NMFCCODE',
			'generalStep.freightClassCode': 'PRODUCTVIEW.FREIGHTCLASSCODE',
		},
		rules: {
			'generalStep.mainSku': 'required',
			'generalStep.name': 'required',
			'generalStep.upc': 'required',
			'generalStep.conditionId': 'required',
			'generalStep.productStatusId': 'required',
			'generalStep.productUpcs[].upc': 'required',
			'generalStep.nmfcCode': 'string',
			'generalStep.freightClassCode': 'numeric|onePointDecimal',
		},
		types: {
			'generalStep.onePerBox': 'checkbox',
			'generalStep.isShippable': 'checkbox',
			'generalStep.isMultiProduct': 'checkbox',
		},
		values: {
			'generalStep.isActive': true,
			'generalStep.onePerBox': true,
			'generalStep.isShippable': true,
			'generalStep.isMultiProduct': false,
		},
	};
}

function ProductEditDimensionsStepForm() {
	return {
		fields: [
			'dimensionsStep.width',
			'dimensionsStep.length',
			'dimensionsStep.height',
			'dimensionsStep.dimensionUnitId',
			'dimensionsStep.weight',
			'dimensionsStep.weightUnitId',
			'dimensionsStep.boxId',
			'dimensionsStep.automaticBox',
			'dimensionsStep.ounces',
			'dimensionsStep.pounds',
		],
		labels: {
			'dimensionsStep.width': 'PRODUCTVIEW.WIDTH',
			'dimensionsStep.length': 'PRODUCTVIEW.LENGTH',
			'dimensionsStep.height': 'PRODUCTVIEW.HEIGHT',
			'dimensionsStep.weight': 'PRODUCTVIEW.KILOGRAMS',
			'dimensionsStep.dimensionUnitId': 'PRODUCTVIEW.DIMENSIONUNIT',
			'dimensionsStep.weightUnitId': 'PRODUCTVIEW.WEIGHTUNIT',
			'dimensionsStep.boxId': 'PRODUCTVIEW.BOX',
			'dimensionsStep.automaticBox': 'PRODUCTVIEW.AUTOMATICBOX',
			'dimensionsStep.ounces': 'PRODUCTVIEW.OUNCES',
			'dimensionsStep.pounds': 'PRODUCTVIEW.POUNDS',
		},
		rules: {
			'dimensionsStep.width': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.length': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.height': 'required|numeric|notZero|numericMinValue|decimalLength',
			'dimensionsStep.dimensionUnitId': 'required',
			'dimensionsStep.weightUnitId': 'required',
			'dimensionsStep.pounds': 'required|numeric|min:0.01',
			'dimensionsStep.ounces': 'numeric|integer',
		},
		types: {
			'dimensionsStep.automaticBox': 'checkbox',
		},
		values: {
			'dimensionsStep.automaticBox': true,
		},
	};
}

function ProductEditVirtualSKUStepForm() {
	return {
		fields: [
			'virtualSKUStep.productVirtualSkus',
			'virtualSKUStep.productVirtualSkus[].id',
			'virtualSKUStep.productVirtualSkus[].sku',
			'virtualSKUStep.productVirtualSkus[].channelId',
			'virtualSKUStep.productVirtualSkus[].description',
			'virtualSKUStep.productVirtualSkus[].isActive',
			'virtualSKUStep.productVirtualSkus[].isNonPrime',
			'virtualSKUStep.productVirtualSkus[].searchId',
			'virtualSKUStep.productVirtualSkus[].postInventory',
			'virtualSKUStep.productVirtualSkus[].carrierIds',
		],
		labels: {
			'virtualSKUStep.productVirtualSkus[].sku': 'PRODUCTVIEW.VIRTUALSKU',
			'virtualSKUStep.productVirtualSkus[].channelId': 'PRODUCTVIEW.CHANNEL',
			'virtualSKUStep.productVirtualSkus[].description': 'PRODUCTVIEW.DESCRIPTION',
			'virtualSKUStep.productVirtualSkus[].isActive': 'PRODUCTVIEW.ISACTIVE',
			'virtualSKUStep.productVirtualSkus[].isNonPrime': 'PRODUCTVIEW.ISNONPRIME',
			'virtualSKUStep.productVirtualSkus[].postInventory': 'PRODUCTVIEW.POSTINVENTORY',
			'virtualSKUStep.productVirtualSkus[].carrierIds': 'PRODUCTVIEW.CARRIERS',
		},
		rules: {
			'virtualSKUStep.productVirtualSkus[].sku': 'required',
			'virtualSKUStep.productVirtualSkus[].channelId': 'required',
		},
		types: {
			'virtualSKUStep.productVirtualSkus[].isActive': 'checkbox',
			'virtualSKUStep.productVirtualSkus[].postInventory': 'checkbox',
			'virtualSKUStep.productVirtualSkus[].isNonPrime': 'checkbox',
		},
	};
}



// WEBPACK FOOTER //
// ./src/modules/product/wizard/forms/ProductEditForm.js